export default {
    _trigger: null,
    _body: null,
    _shadow: null,
    _iconUp: null,
    _iconDown: null,
    init() {
        this._trigger = document.querySelector(".js-fact-box-trigger");

        if(!this._trigger){
            return;
        }

        this._body = document.querySelector(".js-factbox-body");
        this._shadow = document.querySelector(".js-factbox-shadow");
        this.getIcons();
        
        if (this._body.offsetHeight < 300) {
            return;
        }

        this.run();

        this._trigger.addEventListener("click", (e) => {
            this.run();
        });
    },
    run(){
        this.setAria();
        this.setBody();
        this.setInnerBtn();
    },
    isExpanded() {
        return this._trigger.ariaExpanded === "false";
    },
    setAria() {
        this._trigger.ariaExpanded = this.isExpanded() ? "true" : "false";
    },
    setInnerBtn() {
        this._trigger.style.display = "block";
        this._trigger.innerHTML = this.isExpanded()
            ? this._trigger.dataset.textClose + this._iconUp
            : this._trigger.dataset.textOpen + this._iconDown;
    },
    setBody(){
        this._shadow.style.display = this.isExpanded() ? "none" : "block";
        this._body.style.height = this.isExpanded() ? "auto" : 300 + "px";
    },
    getIcons(){
        this._iconUp = this._trigger.dataset.iconUp;
        this._iconDown = this._trigger.dataset.iconDown;
        
        delete this._trigger.dataset.iconUp;
        delete this._trigger.dataset.iconDown;
    }
};
